import React from 'react';
import PropTypes from 'prop-types';
import { Paper, withStyles } from '@material-ui/core';

const styles = (theme) => ({
  root: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    justifyContent: 'center',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  paper: {
    margin: theme.spacing(1),
    width: 400,
    maxWidth: `calc(100% - ${theme.spacing(2)}px)`,
    padding: theme.spacing(4),

    '& h2': {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    },
  },
});

const SmallCenteredPaper = ({ after, children, classes }) => (
  <div className={classes.root}>
    <Paper className={classes.paper}>{children}</Paper>
    {after}
  </div>
);

SmallCenteredPaper.propTypes = {
  after: PropTypes.node,
  children: PropTypes.node,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(SmallCenteredPaper);
